import styled from "styled-components";

export default styled.td`
  padding: 1rem;
  max-width: 106px;
`;
